import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {PoliticasCredito} from '../_models/politicas-credito';
import {PoliticasRoles} from '../_models/politicas-roles';
import {PoliticasRetanqueoProductos} from '../_models/politicas-retanqueo-productos';

@Injectable({
  providedIn: 'root'
})
export class PoliticasRolesService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + '/api/politicasRoles';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) { }

  listadoPoliticasRoles() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PoliticasRoles[] ) );
  }

  listadoPoliticasRolesHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PoliticasRoles[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/idPolitica/' + id ).pipe( map( res => res as PoliticasRoles[] ) );
  }

  bulk(lista: PoliticasRoles[]) {
    lista.map((s: PoliticasRoles) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httClient
      .post(this.rutServicio + "/bulk", lista)
      .pipe(map((res) => res as PoliticasRoles[]));
  }
}
